<template lang="pug">
b-modal#updatePaymentOptionCredential(
  ref="updatePaymentOptionCredential"
  :title="$t('ui.combine.change_payment_option_credential')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    .alert.alert-warning.p-1.mb-2.w-100 *{{ $t("message.whitelist_ip_tooltips", { ip: IP }) }}
    b-form-group(:label="$t('ui.payment_mode')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="payment_mode"
        required
        type="text"
        :dirty="$v.payment_mode.$dirty"
        :error="$v.payment_mode.$error"
        v-model.trim.lazy="$v.payment_mode.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.payment_mode" :name="$t('ui.payment_mode')")
    b-form-group(:label="$t('ui.' + FIELDS[0])" v-if="CREDENTIALS[0]").mb-0
      DebounceInput(
        size="sm"
        ref="credential_1"
        required
        type="text"
        :dirty="$v.credential_1.$dirty"
        :error="$v.credential_1.$error"
        v-model.trim.lazy="$v.credential_1.$model"
        :disabled="loading"
      )
      small.form-text.text-muted(v-if="TOOLTIPS[0]") {{ $t('message.' + TOOLTIPS[0]) }}
      ValidateResult(:value="$v.credential_1" :name="$t('ui.' + FIELDS[0])")
    b-form-group(:label="$t('ui.' + FIELDS[1])" v-if="CREDENTIALS[1]").mb-0
      DebounceInput(
        v-if="!['HIGHHELP','NOVAPAY'].includes(payment_mode)"
        size="sm"
        ref="credential_2"
        required
        type="text"
        :dirty="$v.credential_2.$dirty"
        :error="$v.credential_2.$error"
        v-model.trim.lazy="$v.credential_2.$model"
        :disabled="loading"
      )
      b-form-textarea(
        v-else
        ref="credential_2"
        :dirty="$v.credential_2.$dirty"
        :error="$v.credential_2.$error"
        v-model.trim.lazy="$v.credential_2.$model"
        style="height:70px;"
        :disabled="loading"
      )
      small.form-text.text-muted(v-if="TOOLTIPS[1]") {{ $t('message.' + TOOLTIPS[1]) }}
      ValidateResult(:value="$v.credential_2" :name="$t('ui.'  + FIELDS[1])")
    b-form-group(:label="$t('ui.'  + FIELDS[2])" v-if="CREDENTIALS[2]").mb-0
      DebounceInput(
        v-if="!['HIGHHELP','NOVAPAY'].includes(payment_mode)"
        size="sm"
        ref="credential_3"
        required
        type="text"
        :dirty="$v.credential_3.$dirty"
        :error="$v.credential_3.$error"
        v-model.trim.lazy="$v.credential_3.$model"
        :disabled="loading"
      )
      b-form-textarea(
        v-else
        ref="credential_3"
        :dirty="$v.credential_3.$dirty"
        :error="$v.credential_3.$error"
        v-model.trim.lazy="$v.credential_3.$model"
        style="height:70px;"
        :disabled="loading"
      )
      small.form-text.text-muted(v-if="TOOLTIPS[2]") {{ $t('message.' + TOOLTIPS[2]) }}
      ValidateResult(:value="$v.credential_3" :name="$t('ui.' + FIELDS[2])")
    b-form-group(:label="$t('ui.' + FIELDS[3])" v-if="CREDENTIALS[3]").mb-0
      DebounceInput(
        v-if="!['HIGHHELP','SECUREPAY','NOVAPAY'].includes(payment_mode)"
        size="sm"
        ref="credential_4"
        required
        type="text"
        :dirty="$v.credential_4.$dirty"
        :error="$v.credential_4.$error"
        v-model.trim.lazy="$v.credential_4.$model"
        :disabled="loading"
      )
      b-form-textarea(
        v-else
        ref="credential_4"
        :dirty="$v.credential_4.$dirty"
        :error="$v.credential_4.$error"
        v-model.trim.lazy="$v.credential_4.$model"
        style="height:70px;"
        :disabled="loading"
      )
      small.form-text.text-muted(v-if="TOOLTIPS[3]") {{ $t('message.' + TOOLTIPS[3]) }}
      ValidateResult(:value="$v.credential_4" :name="$t('ui.' + FIELDS[3])")
    b-form-group(:label="$t('ui.' + FIELDS[4])" v-if="CREDENTIALS[4]").mb-0
      DebounceInput(
        v-if="!['TRUSTPAY','SECUREPAY'].includes(payment_mode)"
        size="sm"
        ref="credential_5"
        required
        type="text"
        :dirty="$v.credential_5.$dirty"
        :error="$v.credential_5.$error"
        v-model.trim.lazy="$v.credential_5.$model"
        :disabled="loading"
      )
      b-form-textarea(
        v-else
        ref="credential_5"
        :dirty="$v.credential_5.$dirty"
        :error="$v.credential_5.$error"
        v-model.trim.lazy="$v.credential_5.$model"
        style="height:70px;"
        :disabled="loading"
      )
      small.form-text.text-muted(v-if="TOOLTIPS[4]") {{ $t('message.' + TOOLTIPS[4]) }}
      ValidateResult(:value="$v.credential_5" :name="$t('ui.' + FIELDS[4])")
    b-form-group(:label="$t('ui.' + FIELDS[5])" v-if="CREDENTIALS[5]").mb-0
      DebounceInput(
        v-if="!['TRUSTPAY'].includes(payment_mode)"
        size="sm"
        ref="credential_6"
        required
        type="text"
        :dirty="$v.credential_6.$dirty"
        :error="$v.credential_6.$error"
        v-model.trim.lazy="$v.credential_6.$model"
        :disabled="loading"
      )
      b-form-textarea(
        v-else
        ref="credential_6"
        :dirty="$v.credential_6.$dirty"
        :error="$v.credential_6.$error"
        v-model.trim.lazy="$v.credential_6.$model"
        style="height:70px;"
        :disabled="loading"
      )
      small.form-text.text-muted(v-if="TOOLTIPS[5]") {{ $t('message.' + TOOLTIPS[5]) }}
      ValidateResult(:value="$v.credential_6" :name="$t('ui.' + FIELDS[5])")
    b-form-group(:label="$t('ui.' + FIELDS[6])" v-if="CREDENTIALS[6]").mb-0
      DebounceInput(
        size="sm"
        ref="credential_7"
        required
        type="text"
        :dirty="$v.credential_7.$dirty"
        :error="$v.credential_7.$error"
        v-model.trim.lazy="$v.credential_7.$model"
        :disabled="loading"
      )
      small.form-text.text-muted(v-if="TOOLTIPS[6]") {{ $t('message.' + TOOLTIPS[6]) }}
      ValidateResult(:value="$v.credential_7" :name="$t('ui.' + FIELDS[6])")
    b-form-group(:label="$t('ui.' + FIELDS[7])" v-if="CREDENTIALS[7]").mb-0
      DebounceInput(
        size="sm"
        ref="credential_8"
        required
        type="text"
        :dirty="$v.credential_8.$dirty"
        :error="$v.credential_8.$error"
        v-model.trim.lazy="$v.credential_8.$model"
        :disabled="loading"
      )
      small.form-text.text-muted(v-if="TOOLTIPS[7]") {{ $t('message.' + TOOLTIPS[7]) }}
      ValidateResult(:value="$v.credential_8" :name="$t('ui.' + FIELDS[7])")
    b-form-group(:label="$t('ui.' + FIELDS[8])" v-if="CREDENTIALS[8]").mb-0
      DebounceInput(
        size="sm"
        ref="credential_9"
        required
        type="text"
        :dirty="$v.credential_9.$dirty"
        :error="$v.credential_9.$error"
        v-model.trim.lazy="$v.credential_9.$model"
        :disabled="loading"
      )
      small.form-text.text-muted(v-if="TOOLTIPS[8]") {{ $t('message.' + TOOLTIPS[8]) }}
      ValidateResult(:value="$v.credential_9" :name="$t('ui.' + FIELDS[8])")
    b-form-group(:label="$t('ui.' + FIELDS[9])" v-if="CREDENTIALS[9]").mb-0
      DebounceInput(
        size="sm"
        ref="credential_10"
        required
        type="text"
        :dirty="$v.credential_10.$dirty"
        :error="$v.credential_10.$error"
        v-model.trim.lazy="$v.credential_10.$model"
        :disabled="loading"
      )
      small.form-text.text-muted(v-if="TOOLTIPS[9]") {{ $t('message.' + TOOLTIPS[9]) }}
      ValidateResult(:value="$v.credential_10" :name="$t('ui.' + FIELDS[9])")
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, requiredIf, maxLength } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      payment_mode: "",
      CREDENTIALS: [],
      FIELDS: [],
      IP: config.proxyIP,
      credential_1: "",
      credential_2: "",
      credential_3: "",
      credential_4: "",
      credential_5: "",
      credential_6: "",
      credential_7: "",
      credential_8: "",
      credential_9: "",
      credential_10: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    }
  },
  validations: {
    payment_mode: {
      required
    },
    credential_1: {
      required,
      maxLength: maxLength(4000)
    },
    credential_2: {
      required: requiredIf(function () {
        return ['INPAY','MGMPAY','GSPAY','LUXEPAY','LUXEPAYQR','ONEPAY','BESTPAY','YESPAY','TIMEPAY',
                'FPAY','FPAYQR','DGPAY','DAYANGPAY','AMOPAY','ONEVNPAY','CLUBSPAY','TRUEPAY','HIGHHELP',
                'SECRETPAY','UBIT','WOWPAY','ONEPAYMY','TRUSTPAY','ROCKETX','JUPITER','AMPAY','TIGERPAY',
                'EPICPAY','ONEMPAY','SECUREPAY','NIRVANA','TAKAPAY','BCATPAY','TTPAY','AUTOPAY','GLOBALPAY',
                'JPAY','SECRETPAYMY','METAPAY','DGPAYQR','SECRETPAYQRMY','VPAY','MPIN','BCATPAYVN','SOLIDPAY',
                'KPAYVN','VADERPAY','VADERPAYQR','PEPAY','NOVAPAY','DIREPAY','PEPAYPIN','GSPAYQR'].includes(this.payment_mode);
      }),
      maxLength: maxLength(4000)
    },
    credential_3: {
      required: requiredIf(function () {
        return ['INPAY','MGMPAY','ONEPAY','FPAY','FPAYQR','AMOPAY','HIGHHELP','SECRETPAY','UBIT','WOWPAY',
                'ONEPAYMY','TRUSTPAY','JUPITER','TIGERPAY','SECUREPAY','SECRETPAYMY','SECRETPAYQRMY','MPIN',
                'SOLIDPAY','DIREPAY','NOVAPAY'].includes(this.payment_mode);
      }),
      maxLength: maxLength(4000)
    },
    credential_4: {
      required: requiredIf(function () {
        return ['MGMPAY','HIGHHELP','TRUSTPAY','JUPITER','SECUREPAY','NOVAPAY'].includes(this.payment_mode);
      }),
      maxLength: maxLength(4000)
    },
    credential_5: {
      required: requiredIf(function () {
        return ['TRUSTPAY','SECUREPAY','NOVAPAY'].includes(this.payment_mode);
      }),
      maxLength: maxLength(4000)
    },
    credential_6: {
      required: requiredIf(function () {
        return ['TRUSTPAY'].includes(this.payment_mode);
      }),
      maxLength: maxLength(4000)
    },
    credential_7: {
      maxLength: maxLength(4000)
    },
    credential_8: {
      maxLength: maxLength(4000)
    },
    credential_9: {
      maxLength: maxLength(4000)
    },
    credential_10: {
      maxLength: maxLength(4000)
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    showCredential(mode) {
      switch(mode) {
        //Russia
        case "INPAY":
          this.CREDENTIALS = [1,1,1,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "api_url", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, "tooltips_inpay_api_url", null, null, null, null, null, null, null]
          break
        case "ONEPAY":
          this.CREDENTIALS = [1,1,1,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant_key", "aes_key", "paycode", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "PROPAYLLER":
          this.CREDENTIALS = [1,0,0,0,0,0,0,0,0,0]
          this.FIELDS = ["api_key", "credential_2", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        //Argentina
        case "MGMPAY":
          this.CREDENTIALS = [1,1,1,1,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "app_id", "deposit_secret_key", "withdrawal_secret_key", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "ROCKETX":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["private_key", "public_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        //Russia & Argentina
        // case "GSPAY":
        //   this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
        //   this.FIELDS = ["authentication_key", "secret_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
        //   this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
        //   break
        case "AMOPAY":
          this.CREDENTIALS = [1,1,1,0,0,0,0,0,0,0]
          this.FIELDS = ["private_key", "public_key", "api_key", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "HIGHHELP":
          this.CREDENTIALS = [1,1,1,1,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "private_key", "public_key", "callback_public_key", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "MERCURIO":
          this.CREDENTIALS = [1,0,0,0,0,0,0,0,0,0]
          this.FIELDS = ["api_key", "credential_2", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "JUPITER":
          this.CREDENTIALS = [1,1,1,1,0,0,0,0,0,0]
          this.FIELDS = ["deposit_token", "deposit_secret_key", "withdrawal_token", "withdrawal_secret_key", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "AMPAY":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["private_key", "public_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "NIRVANA":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["private_key", "public_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        //Malaysia
        case "LUXEPAY":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "api_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "LUXEPAYQR":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "api_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "FPAY":
          this.CREDENTIALS = [1,1,1,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "api_key", "secret_key", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "FPAYQR":
          this.CREDENTIALS = [1,1,1,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "api_key", "secret_key", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "DGPAY":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "TRUEPAY":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "ONEPAYMY":
          this.CREDENTIALS = [1,1,1,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "api_key", "secret_key", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "TRUSTPAY":
          this.CREDENTIALS = [1,1,1,1,1,1,0,0,0,0]
          this.FIELDS = ["version_no", "client_id", "symmetric_key", "secret_key", "public_key", "private_key", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "EPICPAY":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "ONEMPAY":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "SECUREPAY":
          this.CREDENTIALS = [1,1,1,1,1,0,0,0,0,0]
          this.FIELDS = ["client_id", "symmetric_key", "secret_key", "public_key", "private_key", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "JPAY":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "TTPAY":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "AUTOPAY":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["api_key", "institute_bank_code", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "SECRETPAYMY":
          this.CREDENTIALS = [1,1,1,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "api_key", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "METAPAY":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "DGPAYQR":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "SECRETPAYQRMY":
          this.CREDENTIALS = [1,1,1,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "api_key", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "VPAY":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "api_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "MPIN":
          this.CREDENTIALS = [1,1,1,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "api_key", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "VADERPAY":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "api_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "VADERPAYQR":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "api_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "GSPAY":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["authentication_key", "secret_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "PEPAY":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "NOVAPAY":
          this.CREDENTIALS = [1,1,1,1,1,0,0,0,0,0]
          this.FIELDS = ["merchant", "private_key", "public_key", "callback_public_key", "secret_key", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "DIREPAY":
          this.CREDENTIALS = [1,1,1,0,0,0,0,0,0,0]
          this.FIELDS = ["api_email", "api_password", "secret_key", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "PEPAYPIN":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "GSPAYQR":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["authentication_key", "secret_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        //Vietnam
        case "BESTPAY":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "YESPAY":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "TIMEPAY":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "DAYANGPAY":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "ONEVNPAY":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "CLUBSPAY":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "SECRETPAY":
          this.CREDENTIALS = [1,1,1,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "api_key", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "UBIT":
          this.CREDENTIALS = [1,1,1,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant_name", "keyss", "iv", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "WOWPAY":
          this.CREDENTIALS = [1,1,1,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "deposit_secret_key", "withdrawal_secret_key", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "GLOBALPAY":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "BCATPAYVN":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "SOLIDPAY":
          this.CREDENTIALS = [1,1,1,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant_uid", "merchant_no", "secret_key", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "KPAYVN":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        //Bangladesh
        case "TIGERPAY":
          this.CREDENTIALS = [1,1,1,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "api_key", "secret_key", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "TAKAPAY":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        case "BCATPAY":
          this.CREDENTIALS = [1,1,0,0,0,0,0,0,0,0]
          this.FIELDS = ["merchant", "secret_key", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          break
        default:
          this.CREDENTIALS = [1,1,1,1,1,1,1,1,1,1]
          this.FIELDS = ["credential_1", "credential_2", "credential_3", "credential_4", "credential_5", "credential_6", "credential_7", "credential_8", "credential_9", "credential_10"]
          this.TOOLTIPS = [null, null, null, null, null, null, null, null, null, null]
          this.IP = "";
          break
      }
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.paymentOptionUpdateCredentialUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          payment_mode: this.payment_mode,
          credential_1: this.credential_1,
          credential_2: this.credential_2,
          credential_3: this.credential_3,
          credential_4: this.credential_4,
          credential_5: this.credential_5,
          credential_6: this.credential_6,
          credential_7: this.credential_7,
          credential_8: this.credential_8,
          credential_9: this.credential_9,
          credential_10: this.credential_10
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.updatePaymentOptionCredential.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "change_payment_option_credential", this.feedback.status);
                  this.$refs.updatePaymentOptionCredential.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.payment_mode = "";
      this.credential_1 = ""
      this.credential_2 = ""
      this.credential_3 = ""
      this.credential_4 = ""
      this.credential_5 = ""
      this.credential_6 = ""
      this.credential_7 = ""
      this.credential_8 = ""
      this.credential_9 = ""
      this.credential_10 = ""
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.payment_mode = this.item.payment_mode;
      this.showCredential(this.payment_mode)
      this.credential_1 = this.item.credential_1
      this.credential_2 = this.item.credential_2
      this.credential_3 = this.item.credential_3
      this.credential_4 = this.item.credential_4
      this.credential_5 = this.item.credential_5
      this.credential_6 = this.item.credential_6
      this.credential_7 = this.item.credential_7
      this.credential_8 = this.item.credential_8
      this.credential_9 = this.item.credential_9
      this.credential_10 = this.item.credential_10
      // this.$refs.credential_1.$el.focus();
    }
  }
};
</script>
